import type { ComponentChildren } from 'preact';

function Icon({ children, size = 22 }: { children: ComponentChildren; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const IconMap = () => (
  <Icon>
    <rect x="4" y="3" width="16" height="18" rx="3" />
    <path d="M8.5 7.5h2M13.5 7.5h2M8.5 12h2M13.5 12h2M8.5 16.5h2M13.5 16.5h2" />
  </Icon>
);

export const IconBolt = () => (
  <Icon>
    <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
  </Icon>
);

export const IconChat = () => (
  <Icon>
    <path d="M4 5h16v11H9l-5 4z" />
  </Icon>
);

export const IconVote = () => (
  <Icon>
    <path d="M4 13h16v7H4z" />
    <path d="M8 13V4h8v9" />
    <path d="m10 8 1.5 1.5L14 7" />
  </Icon>
);

export const IconGear = () => (
  <Icon>
    <path d="M10.3 2h3.4l.5 2.6 1.7.8 2.3-1.4 2.4 2.4-1.4 2.3.8 1.7 2.6.5v3.4l-2.6.5-.8 1.7 1.4 2.3-2.4 2.4-2.3-1.4-1.7.8-.5 2.6h-3.4l-.5-2.6-1.7-.8-2.3 1.4-2.4-2.4 1.4-2.3-.8-1.7L2 13.7v-3.4l2.6-.5.8-1.7-1.4-2.3 2.4-2.4 2.3 1.4 1.7-.8zM12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" />
  </Icon>
);

export const IconPlane = () => (
  <Icon>
    <path d="M12 2c1 0 2 1.5 2 4v5l7 4v2l-7-2v4l2 2v1l-4-1-4 1v-1l2-2v-4l-7 2v-2l7-4V6c0-2.5 1-4 2-4z" />
  </Icon>
);

export function IconBomb({ size = 14 }: { size?: number }) {
  return (
    <svg class="icon-bomb" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="10" cy="14" r="7" fill="currentColor" />
      <path d="M14 8l3-3M17 5h2M17 5V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
  );
}

export function IconCart({ size = 18 }: { size?: number }) {
  return (
    <svg class="icon-cart" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="3" width="14" height="15" rx="2" fill="currentColor" />
      <path d="M5 9h14M5 13h14" stroke="#0a1324" stroke-width="1.5" />
      <circle cx="8" cy="20.5" r="1.8" fill="currentColor" />
      <circle cx="16" cy="20.5" r="1.8" fill="currentColor" />
    </svg>
  );
}

export function IconSound({ muted }: { muted: boolean }) {
  return (
    <Icon size={18}>
      <path d="M4 9h4l5-4v14l-5-4H4z" />
      {muted ? <path d="m16 9 5 6M21 9l-5 6" /> : <path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" />}
    </Icon>
  );
}
